<template>
  <footer class="footer">
    <div class="bx-1200">
      <div class="left">
        <img class="footer-logo" src="@/assets/images/footer_logo.png" alt="footer" />
        <img class="footer-left" src="@/assets/images/footer_left.png" alt="footer" />
      </div>
      <div class="right">
        <img class="foo-img" src="@/assets/images/footer.png" alt="footer" />
        <div class="txt">
          <div class="foo-main">恶霸犬俱乐部 Bully Club</div>
          <div>2025 © All Rights Reserved</div>
        </div>
      </div>
    </div>
  </footer>
</template>

<script setup lang="ts"></script>

<style lang="less" scoped>
.footer {
  padding-top: 41px;
  height: 145px;
  background: #dbbfa7 url('@/assets/images/footer_bg.png') center / cover no-repeat;
  font-size: 12px;
  color: #585858cc;
  text-align: center;
  box-sizing: border-box;
}

.foo-main {
  margin-bottom: 7px;
}

.foo-img {
  width: 320px;
  height: auto;
  margin-bottom: 7px;
  transform: translateX(12px);
}

.left {
  display: flex;
  align-items: center;
}

.right {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
}

.footer-logo {
  height: 76px;
}

.footer-left {
  margin-left: 30px;
  width: 170px;
  height: auto;
}

.bx-1200 {
  margin: 0 auto;
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 1200px;
}
</style>
